<template>
    <div  :style="{'height':clientHeight-90+'px'}">
        <div>
            <div class="m-portlet m-b-10" :style="{'height':(160)+'px'}">
                <div class="m-portlet__body" >
                    <el-form label-width="120px">
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-form-item label="班主任">
                                    <el-select v-model="form.headTeacher_id" clearable placeholder="请选择班主任"
                                               filterable remote
                                               :remote-method="handleSearchHeadTeacher"
                                               @change="handleChange()">
                                        <el-option
                                                v-for="item in headTeachers"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="学校">
                                    <el-select v-model="form.school_id" clearable placeholder="请选择学校" filterable
                                               remote
                                               :remote-method="handleSearchSchool" @change="handleChange()">
                                        <el-option
                                                v-for="item in schools"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="年级">
                                    <el-select v-model="form.grade_id" clearable placeholder="请选择年级"
                                               @change="handleChange()">
                                        <el-option
                                                v-for="item in grades"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="学生名字">
                                    <el-select v-model="form.student_id" clearable placeholder="请选择学生名字" filterable
                                               remote
                                               :remote-method="handleSearchStudent" @change="handleChange()">
                                        <el-option
                                                v-for="item in haveStudents"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-form-item label="待续班学期">
                                    <el-select v-model="form.semesterType_id" placeholder="请选择学期"
                                               @change="handleChange()">
                                        <el-option
                                                v-for="item in semesterTypes"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="是否有续班学生">
                                    <el-select v-model="form.renewalStudent" clearable placeholder="请选择是否有续班学生"
                                               @change="handleChange()">
                                        <el-option
                                                v-for="item in renewalStudents"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="学科">
                                    <el-select v-model="form.subject_id" clearable placeholder="请选择学科"
                                               @change="handleChange()">
                                        <el-option
                                                v-for="item in subjects"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="续班个数">
                                    <el-select v-model="form.classNumber" clearable placeholder="请选择个数"
                                               @change="handleChange()">
                                        <el-option
                                                v-for="item in classNumbers"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <div class="m-portlet m-b-0" :style="{'height':(clientHeight-270)+'px'}">
                <div class="m-portlet__body" v-loading="loading" :style="{'height':clientHeight-300+'px'}">
                    <el-table
                            :data="orderStudents"
                            style="width: 100%"
                            size="middle"
                            :height="clientHeight-360"
                    >
                        <el-table-column prop="name" label="姓名"></el-table-column>
                        <el-table-column label="学校">
                            <template slot-scope="scope">
                                <span v-if="scope.row.current_education && scope.row.current_education.school">{{scope.row.current_education.school.name}}</span>
                                <span v-else>学校未添加</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="年级">
                            <template slot-scope="scope">
                                <span v-if="scope.row.current_education && scope.row.current_education.grade">{{scope.row.current_education.grade.name}}</span>
                                <span v-else>年级未添加</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="班主任">
                            <template slot-scope="scope">
                                <span v-for="(headTeacher,index) in scope.row.headTeachers" :key="index"> {{headTeacher.name}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column width="200">
                            <template slot="header" slot-scope="scope">
                                {{oneSemesterType.name}}课程(now)
                            </template>
                            <template slot-scope="scope">
                                <div v-for="(now_class,index) in scope.row.nowClasses" :key="index"
                                     style="float: left">
                                    {{now_class.name}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="200">
                            <template slot="header" slot-scope="scope">
                                {{twoSemesterType.name}}课程(next)
                            </template>
                            <template slot-scope="scope">
                                <span v-if="scope.row.nextClasses_number==0">没报班</span>
                                <div v-else v-for="(next_class,index) in scope.row.nextClasses" :key="index"
                                     style="float: left">
                                    {{next_class.name}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="nextClasses_number" label="续班个数"></el-table-column>
                        <el-table-column width="200" v-if="threeSemesterType">
                            <template slot="header" slot-scope="scope">
                                {{threeSemesterType.name}}课程(next)
                            </template>
                            <template slot-scope="scope">
                                <span v-if="scope.row.nextSecondClasses_number==0">没报班</span>
                                <div v-else v-for="(next_class,index) in scope.row.nextSecondClasses" :key="index"
                                     style="float: left">
                                    {{next_class.name}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="nextSecondClasses_number" label="续班个数" v-if="threeSemesterType"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button size="mini"
                                           @click="handleStudentInformation(scope.row.id,scope.row.name)">查看详情
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页-->
                    <div class="text-center m-t-10">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "RenewalList",
        data() {
            return {
                loading: true,
                path: "/renewalStudent/list",
                headTeachers: [],
                form: {
                    headTeacher_id: '',
                    school_id: '',
                    grade_id: '',
                    student_id: '',
                    semesterType_id: '',
                    renewalStudent: '',
                    subject_id: '',
                    classNumber: '',
                },

                schools: [],
                grades: [],
                haveStudents: [],
                semesterTypes: [],
                subjects: [],
                students: [],

                renewalStudents: [{
                    value: '0',
                    label: '无续班学生'
                }, {
                    value: '1',
                    label: '续班学生'
                }],
                classNumbers: [{
                    value: '0',
                    label: '三个以下'
                }, {
                    value: '1',
                    label: '三个和三个以上'
                }],

                total: 0,
                currentPage: 1,
                currentPageSize: 10,

                oneSemesterType: '',
                twoSemesterType: '',
                threeSemesterType:''
            }
        },
        mounted() {
            this.$nextTick(() => {
            })
        },
        created() {
            this.handleCreate();
            this.handleShow();
            this.handleIndexRenewalList();
        },
        computed: {
            right_level() {
                return this.$store.state.user.employee.right_level;
            },
            orderStudents: function () {
                return this._.values(this.students);
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleSearchSchool(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'schoolKeyName',
                    'schoolKeyName': query,
                });
            },
            handleSearchHeadTeacher(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'headTeacherKeyName',
                    'headTeacherKeyName': query,
                });
            },
            handleSearchStudent(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'studentKeyName',
                    'studentKeyName': query,
                });
            },
            handleChange() {
                this.loading = true;
                this.handleIndexRenewalList();
            },
            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleShow() {
                this.$wApi.send(this.path, 'init', {});
            },
            handleData(event, data) {
                switch (event) {
                    case 'init':
                        this.semesters = data.semesters;
                        this.grades = data.grades;
                        this.subjects = data.subjects;
                        this.semesterTypes = data.semesterTypes;

                        this.schools = data.schools;
                        this.headTeachers = data.headTeachers;
                        this.haveStudents = data.haveStudents;
                        break;
                    case 'searchSchool':
                        this.schools = data.searchData;
                        break;
                    case 'searchHeadTeacher':
                        this.headTeachers = data.searchData;
                        break;
                    case 'searchStudent':
                        this.haveStudents = data.searchData;
                        break;
                    case 'list':
                        this.total = data.total;
                        this.oneSemesterType = data.oneSemesterType;
                        this.twoSemesterType = data.twoSemesterType;
                        this.threeSemesterType = data.threeSemesterType;
                        this.students = data.students;
                        this.form.semesterType_id = data.oneSemesterType.id;
                        this.loading = false;
                        break;
                    case 'list_error':
                        this.total = 0;
                        this.oneSemesterType =[];
                        this.twoSemesterType = [];
                        this.students = [];
                        this.form.semesterType_id = '';
                        this.loading = false;
                        break;
                }
            },
            handleIndexRenewalList(currentPage = 1) {
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': this.currentPage,
                    'currentPageSize': this.currentPageSize,
                    'form': this.form,
                    'nowSemester_id': this.$store.state.config.nowSemester.id,
                });
            },
            handleStudentInformation(student_id, title) {
                    this.$store.dispatch('addView', {
                    'title': title,
                    'path': '/student/' + student_id,
                    'closable': true
                });
                this.router.push({path: '/student/' + student_id})
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexRenewalList(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexRenewalList(this.currentPage, this.currentPageSize)
            },
        }
    }
</script>

<style scoped>

</style>
